import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { TEST_RESULTS, TEST_MEDIA, PRESSURE_PRESETS } from "@/lib/constants";
import { Section, Field } from "./fields";
import { NONE, toSelectValue, fromSelectValue } from "./selectValue";

export const TestParamsSection = ({ form, update, customPressure, setCustomPressure, testers, fp = () => ({}) }) => (
  <Section title="Test parameters" number="02">
    <Field label="Test result" {...fp("test_result")}>
      <Select
        value={form.test_result || "Pending"}
        onValueChange={(v) => update({ test_result: v })}
      >
        <SelectTrigger data-testid="test-result-select" className="border-[#33424f]/30">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {TEST_RESULTS.map((r) => (
            <SelectItem key={r} value={r}>{r}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Field>

    <Field label="Test pressure *" {...fp("test_pressure")}>
      <div className="space-y-2">
        <Select
          value={customPressure ? "custom" : toSelectValue(form.test_pressure)}
          onValueChange={(v) => {
            if (v === "custom") {
              setCustomPressure(true);
              update({ test_pressure: "" });
            } else {
              setCustomPressure(false);
              update({ test_pressure: fromSelectValue(v) });
            }
          }}
        >
          <SelectTrigger data-testid="test-pressure-select" className="border-[#33424f]/30">
            <SelectValue placeholder="—" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={NONE}>—</SelectItem>
            {PRESSURE_PRESETS.map((p) => (
              <SelectItem key={p} value={p}>{p}</SelectItem>
            ))}
            <SelectItem value="custom">Custom…</SelectItem>
          </SelectContent>
        </Select>
        {customPressure && (
          <Input
            data-testid="custom-pressure-input"
            placeholder="e.g. 42 bar"
            value={form.test_pressure}
            onChange={(e) => update({ test_pressure: e.target.value })}
            className="border-[#33424f]/30"
          />
        )}
      </div>
    </Field>

    <Field label="Test medium *" {...fp("test_medium")}>
      <Select
        value={toSelectValue(form.test_medium)}
        onValueChange={(v) => {
          const m = fromSelectValue(v);
          if (m) update({ test_medium: m });
        }}
      >
        <SelectTrigger data-testid="test-medium-select" className="border-[#33424f]/30">
          <SelectValue placeholder="—" />
        </SelectTrigger>
        <SelectContent>
          {TEST_MEDIA.map((m) => (
            <SelectItem key={m} value={m}>{m}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Field>

    <Field label="Test person *" {...fp("test_person_id")}>
      <Select
        value={toSelectValue(form.test_person_id)}
        onValueChange={(v) => {
          const id = fromSelectValue(v);
          if (id) update({ test_person_id: id });
        }}
      >
        <SelectTrigger data-testid="test-person-select" className="border-[#33424f]/30">
          <SelectValue placeholder="—" />
        </SelectTrigger>
        <SelectContent>
          {testers.map((e) => (
            <SelectItem key={e.id} value={e.id}>{e.name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Field>

    <Field label="Test date *" {...fp("test_date")}>
      <Input
        data-testid="test-date-input"
        type="date"
        required
        value={form.test_date || ""}
        onChange={(e) => update({ test_date: e.target.value })}
        className="border-[#33424f]/30"
      />
    </Field>

    <Field label="Witness tested by NoBo *" {...fp("witness_tested_by_nobo")}>
      <Select
        value={form.witness_tested_by_nobo ? "yes" : "no"}
        onValueChange={(v) => update({ witness_tested_by_nobo: v === "yes" })}
      >
        <SelectTrigger data-testid="witness-nobo-select" className="border-[#33424f]/30">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="no">No</SelectItem>
          <SelectItem value="yes">Yes</SelectItem>
        </SelectContent>
      </Select>
    </Field>
  </Section>
);
